import Icons from './icons.vue'
import IconsModal from './icons-modal.vue'
export { Icons, IconsModal }
export default Icons



// WEBPACK FOOTER //
// ./src/components/icons/index.js